import React from "react";
import TradeTable from "../../components/Table";
import { MisbilledRecord } from "../../types/Records";

interface Props {
  records: MisbilledRecord[];
}

const MisbilledPage = ({ records }: Props) => {
  return (
    <div>
      <TradeTable tradeData={records} />
    </div>
  );
};

export default MisbilledPage;
